import {memo} from 'react'

import {Highlight} from '../../../../common/Highlight/Highlight'
import {getHighlightMatches} from '../../utils/getHighlightMatches'

interface Props {
  value: string
  highlight: string
}

function ParameterHighlightComponent(props: Props) {
  const {value, highlight} = props

  if (highlight.length === 0) {
    return <>{value}</>
  }

  const matches = getHighlightMatches(highlight)(value)

  return <Highlight string={value} matches={matches} />
}

export const ParameterHighlight = memo<Props>(ParameterHighlightComponent)
